import React, { Component, Fragment } from 'react';
import './WebsiteHeader.module.scss';
import {NavLink} from 'react-router-dom';

/**
 * import fontawesome icons
 */
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faBars} from '@fortawesome/pro-regular-svg-icons';

class WebsiteHeader extends Component {

    constructor() {
        super();
        this.state = {
            mobilePopup: false,
            hoveredElement: null,
        }

        this.toggleMenu  = this.toggleMenu.bind(this);
        this.hoverOn        = this.hoverOn.bind(this);
        this.hoverOff       = this.hoverOff.bind(this);
    }

    toggleMenu() {
        this.setState({
            mobilePopup: !this.state.mobilePopup,
        });
    }

    
    hoverOn(elementNumber){
        this.setState({ 
            hoveredElement: elementNumber
        })
    }
    hoverOff(){
        this.setState({ 
            hoveredElement: null
        })
    }

    render() {
        return (
            <Fragment>
                <div styleName='header'>
                    <NavLink to={'/'} styleName='logo'></NavLink>
                    <div styleName='navlink'></div>
                    <NavLink onMouseEnter={()=> {this.hoverOn('1')}} onMouseLeave={this.hoverOff} to={'/'} styleName='navlink link1'>
                        {this.state.hoveredElement == 1 ?
                            <img src='/images/menuknoppen/start.gif'/>
                            :
                            <p>start</p>
                        }
                    </NavLink>
                    <NavLink onMouseEnter={()=> {this.hoverOn('2')}} onMouseLeave={this.hoverOff} to={'/docenten'}  styleName='navlink link2'>
                        {this.state.hoveredElement == 2 ?
                            <img src='/images/menuknoppen/docenten.gif'/>
                            :
                            <p>docenten</p>
                        }
                    </NavLink>
                    <NavLink onMouseEnter={()=> {this.hoverOn('3')}} onMouseLeave={this.hoverOff} to={'/partners'}  styleName='navlink link3'>
                        {this.state.hoveredElement == 3 ?
                            <img src='/images/menuknoppen/partners.gif'/>
                            :
                            <p>partners</p>
                        }
                    </NavLink >
                    <NavLink onMouseEnter={()=> {this.hoverOn('4')}} onMouseLeave={this.hoverOff} to={'/over-ons'}  styleName='navlink link4'>
                        {this.state.hoveredElement == 4 ?
                            <img src='/images/menuknoppen/over_ons.gif'/>
                            :
                            <p>over ons</p>
                        }
                    </NavLink>
                    <NavLink onMouseEnter={()=> {this.hoverOn('5')}} onMouseLeave={this.hoverOff} to={'/platform'} target="_blank" styleName='navlink link5'>
                        {this.state.hoveredElement == 5 ?
                            <img src='/images/menuknoppen/platform.gif'/>
                            :
                            <p>platform</p>
                        }
                    </NavLink>
                    <div onClick={this.toggleMenu} styleName='menu-icon'>
                        <FontAwesomeIcon icon={faBars}/>
                    </div>

                        <div onClick={this.toggleMenu} styleName={ this.state.mobilePopup ? 'menu open' : 'menu'}>
                            { this.state.mobilePopup && <div styleName='overlay'></div>}
                            <div styleName='menu-content'>
                                <NavLink to={'/home'} styleName='menu-item'>
                                    <p>start</p>
                                </NavLink>
                                <NavLink to={'/docenten'}  styleName='menu-item'>
                                    <p>docenten</p>
                                </NavLink>
                                <NavLink to={'/partners'}  styleName='menu-item'>
                                    <p>partners</p>
                                </NavLink >
                                <NavLink to={'/over-ons'}  styleName='menu-item'>
                                    <p>over ons</p>
                                </NavLink>
                                <NavLink to={'/platform'} target="_blank" styleName='menu-item'>
                                    <p>platform</p>
                                </NavLink>
                            </div>
                        </div>
                </div>
                
                <img styleName='hr' src='/images/website/hr.svg'/>
            </Fragment>
        );
    }
}

export default WebsiteHeader;